import Link from 'next/link'
import { MdOutlineHome } from 'react-icons/md'

type BreadcrumbItem = {
  path: string
  label: string
}

type BreadcrumbProps = {
  items?: BreadcrumbItem[]
} & React.HTMLAttributes<HTMLDivElement>

export function Breadcrumb({ items, ...props }: BreadcrumbProps) {
  const validItems = (items ?? []).filter(Boolean)

  return (
    <div
      {...props}
      className={`text-sm md:text-base leading-6 font-title flex flex-row items-center flex-wrap ${props.className}`}
    >
      <Link href="/">
        <MdOutlineHome className="w-4 h-4" />
      </Link>
      {validItems.length > 0 && (
        <>
          <span className="mx-2">&gt;</span>
          {validItems.map((item, index) => (
            <span key={index} className="flex items-center">
              {item.path ? (
                <Link className="hover:underline" href={item.path}>
                  {item.label}
                </Link>
              ) : (
                <p>{item.label}</p>
              )}
              {index < validItems.length - 1 && (
                <span className="mx-2">&gt;</span>
              )}
            </span>
          ))}
        </>
      )}
    </div>
  )
}
